import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Header, FooterPanel } from './components/index';
import { useWindowSize } from '../../utils/hooks';
import { layoutResponsive } from '../../utils/constants';
import AppNotification from '../common/AppNotification/AppNotification';
import classes from './Layout.module.scss';

export default function Layout({ children }) {
  const size = useWindowSize();
  const location = useLocation();
  const appNotification = useSelector((state) => state.appNotifications?.message);

  const [notification, setNotification] = useState(null);

  useEffect(() => {
    setNotification(appNotification);
  }, [appNotification]);

  return (
    <div className={classes.mainContainer}>
      <>
        <Header />
      </>
      {children}
      {size.width <= layoutResponsive && !(location.pathname.includes('jobs') && location.search.includes('id=')) && (
        <FooterPanel />
      )}
      <AppNotification notification={notification} />
    </div>
  );
}
